import { render, staticRenderFns } from "./CabineVideo.vue?vue&type=template&id=bcf2b776&scoped=true"
import script from "./CabineVideo.vue?vue&type=script&lang=js"
export * from "./CabineVideo.vue?vue&type=script&lang=js"
import style0 from "./CabineVideo.scss?vue&type=style&index=0&id=bcf2b776&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2b776",
  null
  
)

export default component.exports